import React, { useEffect, useRef, useState } from 'react';

import styled from 'styled-components';

const SECONDS = 5;


const Box = styled.div`
  border-left: 4px solid ${props => props.theme.colors.blue};
  padding-left: 20px;

  video {
    max-width: 300px;
    border-radius: 12px;
    margin-top: 20px;
  }

  .actions {
    justify-content: flex-start;
  }
`;


const TestMedia = ({ onSuccess }) => {

  const [permissionError, setPermissionError] = useState(null);
  const [recording, setRecording] = useState(false);
  const [recordedUrl, setRecordedUrl] = useState(null);
  const [testing, setTesting] = useState(false);
  const [works, setWorks] = useState(false);

  const videoRef = useRef(null);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);
  const streamRef = useRef(null);

  const startMedia = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      streamRef.current = stream;
      setTesting(true);

      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play().catch(err => {
            console.error('Video playback error:', err);
          });
        }
      }, 100);
    } catch (err) {
      setPermissionError(err.message || 'Media permission denied');
    }
  };

  const handleStartRecording = () => {
    if (!streamRef.current) return;
    chunksRef.current = [];
    const recorder = new MediaRecorder(streamRef.current);
    recorderRef.current = recorder;

    recorder.ondataavailable = e => chunksRef.current.push(e.data);
    recorder.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      setRecordedUrl(url);
    };

    recorder.start();
    setRecording(true);

    setTimeout(() => {
      recorder.stop();
      setRecording(false);
    }, 3000); // 3s recording
  };

  const handleReset = () => {
    setRecordedUrl(null);
    setRecording(false);

    setTimeout(() => {
      if (videoRef.current && streamRef.current) {
        videoRef.current.srcObject = streamRef.current;
        videoRef.current.play().catch(err => {
          console.error('Playback error after reset:', err);
        });
      }
      handleStartRecording();
    }, 100);
  };

  const handleSuccess = () => {
    setWorks(true);
    onSuccess();
  }

  useEffect(() => {
    return () => {
      if (streamRef.current) {
        streamRef.current.getTracks().forEach(track => track.stop());
        streamRef.current = null;
      }
    };
  }, []);

  return (
    <Box>
      <p>
        Some questions in this assessment may require recording your answer.
        <br />
        We'll record a short {SECONDS}-second video to help you test your camera and microphone.
        The recording won't be uploaded — it's only for you to review and confirm everything looks and sounds good.
      </p>

      {testing && (
        <>
          {!recordedUrl && (
            <video
              ref={videoRef}
              autoPlay
              muted
              playsInline
            />
          )}
          {recordedUrl && (
            <video
              src={recordedUrl}
              controls
            />
          )}
        </>
      )}

      {permissionError && <p style={{ color: 'red' }}>{permissionError}</p>}

      <div className="actions">
        {!testing && (
          <button className="primary" onClick={startMedia}>Check Camera and Mic</button>
        )}
        {testing && (
          <>
            {!recording && !recordedUrl && (
              <button className="primary" onClick={handleStartRecording}>Record {SECONDS} seconds</button>
            )}
            {recordedUrl && (
              <>
                <button disabled={works} onClick={handleReset}>Try Again...</button>
                <button disabled={works} onClick={handleSuccess} className="primary" style={{ marginLeft: 10 }}>Works!</button>
              </>
            )}
            {recording && <p>Recording...</p>}
          </>
        )}
      </div>
    </Box>
  );
};

export default TestMedia;
